/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Overage_Contract_NoteInputs */



/**
* | output |
* | --- |
* | "charged separately by your partner" |
*
* @param {Usage_Tab_Overage_Contract_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_overage_contract_note = /** @type {((inputs?: Usage_Tab_Overage_Contract_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Overage_Contract_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("wird von Ihrem Partner separat abgerechnet")
	return /** @type {LocalizedString} */ ("charged separately by your partner")
});